import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './repo.css';

function Repos() {
    const [repos, setRepos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const username = 'arycodes';

    useEffect(() => {
        const fetchRepos = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(`https://repoarycodes.vercel.app/repos/${username}`);
                setRepos(response.data);
            } catch (err) {
                setError('Failed to fetch data');
            }
            setLoading(false);
        };

        fetchRepos();
    }, [username]);

    return (
        <div className="repo-cont">
            {loading && <p>Loading...</p>}
            {error && <p className="error">{error}</p>}
            <div className="repo-list">
                {repos.map((repo) => (
                    <div key={repo.name} className="repo-item">
                        <h2><a href={repo.url} target="_blank" rel="noopener noreferrer">{repo.name}</a></h2>
                        <p className='desc'>{repo.description}</p>
                        <p className='lang'><strong>Languages used:</strong> {Object.keys(repo.languages).join(', ')}</p>
                        <p className='visit'>visit repo<a href={repo.url} target="_blank" rel="noopener noreferrer">{repo.name}</a></p>
                        {/* <p><strong>Stars:</strong> {repo.stargazers_count}</p>
              <p><strong>Forks:</strong> {repo.forks_count}</p>
              <p><strong>Open Issues:</strong> {repo.open_issues_count}</p> */}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Repos;
